import { useInfiniteQuery } from "@tanstack/react-query";
import { leadListsApi } from "../../../libs/landvoice-api";
import { ListSavedSearchesOptions } from "../../../types/neighborhoodSearch";
import { convertLeadListToSavedSearch } from "../utils/convertLeadListToSavedSearch";
import { NS_INFINITE_LIST_SAVED_SEARCHES_CACHE_KEY } from "../constants/cacheKeys";

export const useInfiniteListSavedSearches = (
  options: Omit<ListSavedSearchesOptions, "page"> = {
    showHidden: false,
    showOnlyHidden: false,
    search: "",
    pageSize: 100,
  }
) => {
  const pageSize = options.pageSize || 100;
  return useInfiniteQuery({
    queryKey: [NS_INFINITE_LIST_SAVED_SEARCHES_CACHE_KEY, options],
    queryFn: async ({ pageParam = 0 }) => {
      const { search = "", showHidden, showOnlyHidden } = options;
      const lists = await leadListsApi.getLists(
        showHidden,
        showOnlyHidden,
        search,
        pageParam,
        pageSize
      );
      // Convert LeadList to SavedSearch at fetch time
      const leadLists = lists?.data || [];
      return leadLists.map(convertLeadListToSavedSearch);
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      // If we got fewer items than requested, we've reached the end
      if (lastPage.length < pageSize) {
        return undefined;
      }
      // Return the next offset
      return allPages.length * pageSize;
    },
  });
};